import React from 'react';
import { IconButton } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useDarkMode } from 'providers/DarkModeProvider';

interface DarkModeToggleProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({ 
  size = 'medium', 
  className 
}) => {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  const handleToggle = () => {
    toggleDarkMode();
  };

  return (
    <IconButton
      onClick={handleToggle}
      color="inherit"
      size={size}
      className={className}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDarkMode ? <Brightness7 /> : <Brightness4 />}
    </IconButton>
  );
};

export default DarkModeToggle;